import { lazy } from "react";
import ventasRoutes from "../modules/ventas/ventas.routes.jsx";
import comprasRoutes from "../modules/compras/compras.routes.jsx";
import cajaRoutes from "../modules/caja/caja.routes.jsx";
import empresaRoutes from "../modules/empresa/empresa.routes.jsx";
import reportesRoutes from "../modules/reportes/reportes.routes.jsx";
import productosRoutes from "../modules/productos/productos.routes.jsx";
import clientesRoutes from "../modules/clientes/clientes.routes.jsx";
import proveedoresRoutes from "../modules/proveedores/proveedores.routes.jsx";
import finanzasRoutes from "../modules/finanzas/finanzas.routes.jsx";
import suscripcionRoutes from "../modules/suscripcion/suscripcion.routes.jsx";
import operacionRoutes from "../modules/operacion/operacion.routes.jsx";
import configuracionRoutes from "../modules/configuracion/configuracion.routes.jsx";
import sistemaRoutes from "../modules/sistema/sistema.routes.jsx";
import siiRoutes from "../modules/sii/sii.routes.jsx";
import ubicacionesRoutes from "../modules/ubicaciones/ubicaciones.routes.jsx";
import guiasDespachoRoutes from "../modules/ventas/guias-despacho.routes.jsx";
import ordenTrabajoRoutes from "../modules/ventas/orden-trabajo.routes.jsx";
import agendaRoutes from "../modules/agenda/agenda.routes.jsx";
import operacionesRoutes from "../modules/operaciones/operaciones.routes.jsx";
import ordenCompraRoutes from "../modules/ordencompra/ordencompra.routes.jsx";
// import asesorCompraRoutes from "../modules/asesor-compra/asesor-compra.routes.jsx"; // Asesor de Compra: pendiente de liberar
import historiaRoutes from "../modules/historia/historia.routes.jsx";
import despachosPendientesRoutes from "../modules/stock/despachos-pendientes.routes.jsx";
import propiedadesRoutes from "../modules/propiedades/propiedades.routes.jsx";

const App = lazy(() => import("../App.jsx"));
const MainLayout = lazy(() => import("../components/layout/MainLayout.jsx"));
const Home = lazy(() => import("../Home.jsx"));


const appRoutes = [
      {
            path: "/",
            element: <App />,
            children: [
                  {
                        path: "/",
                        element: <MainLayout />,
                        children: [
                              {
                                    index: true,
                                    element: <Home />,
                              },
                              ...ventasRoutes,
                              ...comprasRoutes,
                              ...cajaRoutes,
                              ...empresaRoutes,
                              ...reportesRoutes,
                              ...productosRoutes,
                              ...clientesRoutes,
                              ...proveedoresRoutes,
                              ...finanzasRoutes,
                              ...suscripcionRoutes,
                              ...operacionRoutes,
                              ...configuracionRoutes,
                              ...sistemaRoutes,
                              ...siiRoutes,
                              ...ubicacionesRoutes,
                              ...guiasDespachoRoutes,
                              ...ordenTrabajoRoutes,
                              ...agendaRoutes,
                              ...operacionesRoutes,
                              ...ordenCompraRoutes,
                              // ...asesorCompraRoutes, // Asesor de Compra: pendiente de liberar
                              ...historiaRoutes,
                              ...despachosPendientesRoutes,
                              ...propiedadesRoutes,
                        ],
                  },

            ],
      },
];

export default appRoutes;